import { cache } from '../../actions/actionTypes';
const initialState = {};
export default function (state = initialState, action) {
    switch (action.type) {
        case cache.CACHE_FILE_VAULT:
            const cacheFileVaultPayload = action.payload;
            return {
                ...state,
                [cacheFileVaultPayload.uriKey]: { uri: cacheFileVaultPayload.uri, uriKey: cacheFileVaultPayload.uriKey },
            };
        default:
            return state;
    }
}
